export default [
  {
    text: 'Contract Type',
    value: 'typeText',
    sortable: true,
    order: 1,
    hidable: false,
    hidden: false,
  },
  {
    text: 'Contract No.',
    value: 'number',
    sortable: true,
    order: 2,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Purchasing Organization',
    value: 'purchasingOrganizationText',
    sortable: true,
    order: 3,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Vendor',
    value: 'contractor.number',
    sortable: true,
    order: 4,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Agreement Date',
    value: 'agreementDate',
    sortable: true,
    order: 5,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Document Currency',
    value: 'currency',
    sortable: true,
    order: 6,
    hidable: true,
    hidden: false,
  },
  {
    text: 'Actions',
    value: 'actions',
    width: '60px',
    sortable: false,
    order: 7,
    hidable: true,
    hidden: false,
  },
];
